import axios from "axios";

export { createPriceQuote, getSellerPriceQuotes, updatePriceQuoteBasketExpiry };

function createPriceQuote(basketId, expirationTimeInMinutes) {
  const payload = {
    priceQuoteExpiryMins: expirationTimeInMinutes,
    basketId,
  };
  return axios.post("api/createPriceQuote", payload);
}

async function getSellerPriceQuotes() {
  const response = await axios.get("api/getSellerPriceQuotes");
  return response.data.priceQuotes;
}

async function updatePriceQuoteBasketExpiry(priceQuoteId) {
  const payload ={
    priceQuoteId
  };
  const response = await axios.put("api/updatePriceQuoteBasketExpiry", payload);
  return response.data.updatedBasketExpiry;
}
